<template>
  <div>
    <v-menu
      ref="menu"
      v-model="show"
      data-cy="time-field-menu"
      class="menu"
      offset-y
      min-width="auto"
      :close-on-content-click="false"
    >
      <!-- TODO: Placeholder doesn't work great on iOS native time input-->
      <template #activator="{ props }">
        <v-text-field
          v-bind="props"
          v-model="time"
          data-cy="time-field-text-field"
          :label="label"
          :placeholder="placeholder"
          :hint="hint"
          :required="required"
          :rules="rules"
          append-inner-icon="mdi-clock-outline"
          type="time"
          @click:append-inner.stop="openTimePicker"
        />
      </template>
      <v-time-picker
        v-model="time"
        data-cy="time-field-time-picker"
        color="secondary"
        format="24hr"
        :landscape="true"
        @change="save"
      />
    </v-menu>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch } from 'vue';

type ValidationRule = (value) => true | string;

export default defineComponent({
  name: 'TimeField',
  props: {
    modelValue: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array as () => ValidationRule[],
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const show = ref(false);
    const time = ref(props.modelValue);
    const menu = ref(null);

    watch(time, (val) => {
      emit('update:modelValue', val);
    });

    const save = () => {
      show.value = false;
    };

    const openTimePicker = async () => {
      show.value = true;
      await Promise.resolve();
      // try to focus the time picker for keyboard input if possible
      try {
        const picker = document.querySelector('[data-cy="time-field-time-picker"]');
        if (picker) {
          const focusable = picker.querySelector('input, button, [tabindex]');
          if (focusable) (focusable as HTMLElement).focus();
        }
      } catch {
        // Focus target may not exist yet
      }
    };

    return {
      show,
      time,
      save,
      menu,
      openTimePicker,
    };
  },
});
</script>
<style scoped>
.custom-title {
  position: absolute;
  z-index: 10;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.custom-title .buttons {
  display: flex;
  flex-direction: row;
}

.custom-title .buttons .v-btn {
  padding: 0 12px;
  min-width: 32px;
}
</style>
